import { isArray } from '@unfold/utils';
import { ITheme, Theme } from '../../common/types';
import { light, dark } from '../../..';

/**
 * Returns the Theme object corresponding to the string passed
 * 'dark' returns the dark object
 * or else returns the light object
 * @param theme
 * @returns {ITheme} the theme object
 */
export const getTheme = (theme: string): ITheme => theme === Theme.DARK ? dark : light;

export const isPropNotEqualTo = (
  currProp: string,
  propList: string | string[]
): boolean => {
  return isArray(propList)
    ? propList.indexOf(currProp) === -1
    : currProp !== propList;
};
